<div class="app h100p"><router-view></router-view></div>